###
Persist UTM values across client side navigation
###
import {
	addUtmParamsToAnchorsOnClick
	addCurrentUtmToUrl
} from 'library/services/persist-utm'
export default ({ app }) ->

	# Copy query params into URL when doing client side navigation
	app.router.beforeEach (to, from, next) ->

		# Don't act on initial render
		return next() unless from.matched.length

		# Don't pass the url to next unless it's been changed
		newUrl = addCurrentUtmToUrl to.fullPath
		return next() if newUrl == to.fullPath

		# Make a fullPath that is resolvable by Vue Router
		newUrlObj = new URL newUrl, process.env.URL
		newFullPath = "#{newUrlObj.pathname}?#{newUrlObj.searchParams.toString()}"
		return next newFullPath

	# Add support to non-nuxt-links
	addUtmParamsToAnchorsOnClick()
